module.exports = __webpack_public_path__ + "first-5-ir.jpg?3ec573323826e9ae8f1917539fe75abf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-5-ir.jpg
// module id = 514
// module chunks = 0